import styled from 'styled-components'
import { color } from 'styles/theme'
import { Hex2Rgba } from 'utils/helpers'

export const Logo = styled.svg<{color?:string}>`
    color: ${props => props.color ? props.color : color.black};
`